import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPen,
  faFileInvoiceDollar,
  faCircleDollarToSlot,
  faTimesCircle,
  faCertificate,
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import ButtonPlayPause from './ButtonPlayPause';
import SkipAutoSuspend from './SkipAutoSuspend';

export default function Buttons({
  id,
  createdBy,
  modifiedBy,
  timeStamps,
  togglePaymentHistorial,
  toggleCertificateModal,
  toggleConfirmDeleteModal,
  toggleConfirmCommissionModal,
  pauseStudentButton,
  pauseClassActivity,
  changeClassActivity,
  skipAutoSuspend,
  skipAutoSuspendChange,
  skipAutoSuspendFlag,
}) {
  const showCreatedBy = (created, modified, createdAt, modifiedAt) => {
    return (
      <div className="sd-audit">
        {created ? (
          <div>
            Creado por <strong>{created}</strong> el{' '}
            {moment(createdAt).format('L LT')}
          </div>
        ) : null}
        {modified ? (
          <div>
            Modificado por <strong>{modified}</strong> el{' '}
            {moment(modifiedAt).format('L LT')}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className="sd-card sd-actions w-100">
      <div>
        <div className="sd-eyebrow">Acciones de gestión</div>
        <div className="sd-actions-grid">
          <Link to="/students/viewAll" title="Volver al listado">
            <Button
              size="sm"
              variant="outline-secondary"
              className="sd-btn sd-icon-btn"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
          </Link>
          <Link to={`/students/edit/${id}`}>
            <Button size="sm" variant="primary" className="sd-btn sd-btn-primary">
              <FontAwesomeIcon icon={faPen} /> Editar alumno
            </Button>
          </Link>
          <Link to={`/bills/create/${id}`}>
            <Button size="sm" variant="outline-primary" className="sd-btn">
              <FontAwesomeIcon icon={faFileInvoiceDollar} /> Generar comprobante
            </Button>
          </Link>
          <Button
            onClick={togglePaymentHistorial}
            size="sm"
            variant="outline-primary"
            className="sd-btn"
          >
            <FontAwesomeIcon icon={faCircleDollarToSlot} /> Historial de pago
          </Button>
          <Button
            onClick={toggleCertificateModal}
            size="sm"
            variant="outline-success"
            className="sd-btn"
            title="Generar certificado para este alumno"
          >
            <FontAwesomeIcon icon={faCertificate} /> Generar certificado
          </Button>
          <Button
            onClick={toggleConfirmDeleteModal}
            size="sm"
            variant="outline-danger"
            className="sd-btn"
          >
            <FontAwesomeIcon icon={faTimesCircle} /> Eliminar
          </Button>
        </div>
      </div>
      <div className="sd-actions-footer">
        <div style={{ minWidth: 220, flex: 1 }}>
          {showCreatedBy(
            createdBy,
            modifiedBy,
            timeStamps.createdAt,
            timeStamps.modifiedAt
          )}
          <div className="mt-2">
            <SkipAutoSuspend
              statusStudent={skipAutoSuspend}
              action={skipAutoSuspendChange}
              isLoading={skipAutoSuspendFlag}
            />
          </div>
        </div>
        <div className="sd-controls">
          <ButtonPlayPause
            action={pauseStudentButton}
            statusStudent={pauseClassActivity}
            changeClassActivity={changeClassActivity}
          />
        </div>
      </div>
    </div>
  );
}
